import { PdfProFormaType } from '../enums/pdf-pro-forma-type.enum';

export class PdfProFormaTypeHelper {
  public static buildPdfMergeNotificationCardMessage(length: number, pdfDocumentType: PdfProFormaType): string | undefined {
    let msg: { msgPlural: string | undefined; msgSingular: string | undefined } = { msgPlural: undefined, msgSingular: undefined };

    if (pdfDocumentType === PdfProFormaType.ProForma) {
      msg = {
        msgPlural: `PDF de ${length} factures pro formas`,
        msgSingular: `PDF de ${length} facture pro forma`,
      };
    } else if (pdfDocumentType === PdfProFormaType.ProFormaDeliveryFormStatement) {
      msg = {
        msgPlural: `PDF de ${length} relevés de bons`,
        msgSingular: `PDF de ${length} relevé de bons`,
      };
    }

    const message = length > 1 ? msg.msgPlural : msg.msgSingular;
    return message;
  }

  public static buildPdfMergeNotifyMessage(length: number, pdfDocumentType: PdfProFormaType): string | undefined {
    let msg: { msgPlural: string | undefined; msgSingular: string | undefined } = { msgPlural: undefined, msgSingular: undefined };

    if (pdfDocumentType === PdfProFormaType.ProForma) {
      msg = {
        msgPlural: `PDF multiple de ${length} pro formas en cours de génération`,
        msgSingular: `PDF multiple de ${length} pro forma en cours de génération`,
      };
    } else if (pdfDocumentType === PdfProFormaType.ProFormaDeliveryFormStatement) {
      msg = {
        msgPlural: `PDF multiple de ${length} relevés de bons en cours de génération`,
        msgSingular: `PDF multiple de ${length} relevé de bons en cours de génération`,
      };
    }

    const message = length > 1 ? msg.msgPlural : msg.msgSingular;
    return message;
  }

  public static translateEnum(enumValue: PdfProFormaType, pluralFlag = false): string | undefined {
    if (enumValue === PdfProFormaType.ProForma) {
      return pluralFlag ? 'Factures pro forma' : 'Facture pro forma';
    } else if (enumValue === PdfProFormaType.ProFormaDeliveryFormStatement) {
      return pluralFlag ? 'Relevés de bons' : 'Relevé de bons';
    }
    return undefined;
  }
}
